import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import Icon from "@/components/Icon";
import { catColor } from "@/lib/colors";

export default function Worlds() {
  const navigate = useNavigate();
  const [cats, setCats] = useState(null);

  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);

  if (!cats) return <div className="grid place-items-center py-32"><Loader2 className="animate-spin text-indigo-400" size={32} /></div>;

  return (
    <div>
      <h1 className="font-display font-extrabold text-3xl tracking-tight mb-1">Learning Worlds</h1>
      <p className="text-muted-foreground mb-6">Ten worlds of real-life skills. Master each to level up your adulthood.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cats.map((c, i) => {
          const col = catColor(c.color);
          return (
            <motion.button key={c.key} data-testid={`world-card-${c.key}`} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.04 }}
              whileHover={{ y: -5 }} onClick={() => navigate(`/app/worlds/${c.key}`)}
              className={`text-left rounded-3xl p-6 glass border ${col.border} relative overflow-hidden`}>
              <div className={`absolute -right-8 -top-8 h-32 w-32 rounded-full bg-gradient-to-br ${col.grad} opacity-15 blur-2xl`} />
              <div className={`h-14 w-14 rounded-2xl bg-gradient-to-br ${col.grad} grid place-items-center mb-4 shadow-lg`}>
                <Icon name={c.icon} size={28} className="text-white" />
              </div>
              <h2 className="font-display font-extrabold text-xl mb-1">{c.name}</h2>
              <p className="text-muted-foreground text-sm mb-4 line-clamp-2">{c.description}</p>
              <div className="flex items-center justify-between mb-1.5 text-xs">
                <span className="text-muted-foreground">{c.completed_count}/{c.lesson_count} lessons</span>
                <span className={`font-bold ${col.text}`}>{c.progress}%</span>
              </div>
              <div className="h-2 rounded-full bg-white/5 overflow-hidden">
                <div className={`h-full rounded-full bg-gradient-to-r ${col.grad}`} style={{ width: `${c.progress}%` }} />
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
